import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard factory for a specific Operator Console permission key. Runs after the
 * user is loaded so `operator_permissions` from /auth/me is available. Falls
 * back to /operator/overview (which every operator can see).
 */
export function operatorPermissionGuard(permissionKey: string): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    return auth.loadUser().pipe(
      map(() =>
        auth.hasOperatorPermission(permissionKey)
          ? true
          : router.createUrlTree(['/operator/overview']),
      ),
    );
  };
}
